import { RootState } from 'types';
import { initialState } from '.';

export const selectDailyStatuses = (state: RootState) => {
  return state?.symptomTracking?.dailyStatuses || initialState.dailyStatuses;
};

export const selectReminderTime = (state: RootState) => {
  return state?.symptomTracking?.reminderTime || initialState.reminderTime;
};

export const selectIsPeriodReminderEnabled = (state: RootState) => {
  return state?.symptomTracking?.isPeriodReminderEnabled || initialState.isPeriodReminderEnabled;
};

export const selectShouldAskForPeriod = (state: RootState) => {
  return state?.symptomTracking?.shouldAskForPeriod ?? initialState.shouldAskForPeriod;
};

export default {
  selectDailyStatuses,
  selectReminderTime,
  selectIsPeriodReminderEnabled,
  selectShouldAskForPeriod,
};
